
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FormContainer } from "../../../../Components/FormContainer.js";
import { empty, singleton, append, delay, toList } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Input } from "../../../../Components/Input.js";
import { Msg } from "./Types.js";
import { unwrap } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { UserId__get_unwrap, FormState__getValidation } from "../../../../Shared/Shared.js";
import { Feature, isFeatureEnabled } from "../../../../FeatureFlip.js";
import { BusinessUnitSelect } from "../../../../Widgets/BusinessUnitSelect.js";
import { React_useElmish_Z6C327F2E } from "../../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initEdit, update as update_1, initNew } from "./State.js";
import { RouterModule_nav } from "../../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { ofArray } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Skeleton } from "../../../../Components/Skeleton.js";

export function ApiReceiverForm(props) {
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(FormContainer, {
        Children: toList(delay(() => append(singleton(createElement(Input, {
            ComponentState: componentState,
            Label: t("general.name"),
            OnChange: (name) => {
                props.Dispatch(new Msg(0, [name]));
            },
            TestId: "api-receiver-form-name-input",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
            Value: props.ApiReceiver.Name,
        })), delay(() => (isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton(createElement(BusinessUnitSelect, {
            BusinessUnits: props.BusinessUnits,
            FormState: props.FormState,
            OnChange: (value) => {
                props.Dispatch(new Msg(2, [value]));
            },
            SelectedBusinessUnitId: unwrap(props.ApiReceiver.BusinessUnitId),
        })) : empty()) : empty()))))),
        Header: props.Header,
        OnBack: props.OnBack,
        OnSave: props.OnSave,
    });
}

export function NewApiReceiverView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initNew, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.AccountSettings;
    const matchValue_2 = state_1.BusinessUnits;
    let matchResult, accountSettings, apiReceiver, businessUnits;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_1.fields[0];
        apiReceiver = matchValue.fields[0];
        businessUnits = matchValue_2.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(ApiReceiverForm, {
                AccountSettings: accountSettings,
                ApiReceiver: apiReceiver,
                BusinessUnits: businessUnits,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("api_receiver.create_new_api_receiver"),
                OnBack: () => {
                    RouterModule_nav(ofArray(["settings", "user-management", "api"]), 1, 1);
                },
                OnSave: () => {
                    dispatch(new Msg(3, []));
                },
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

export function ApiReceiverEditView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initEdit, update_1, (_arg, _arg_1) => {
    }), props.ApiReceiverId, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.AccountSettings;
    const matchValue_2 = state_1.BusinessUnits;
    let matchResult, accountSettings, apiReceiver, businessUnits;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_1.fields[0];
        apiReceiver = matchValue.fields[0];
        businessUnits = matchValue_2.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(ApiReceiverForm, {
                AccountSettings: accountSettings,
                ApiReceiver: apiReceiver,
                BusinessUnits: businessUnits,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("api_receiver.edit_api_receiver"),
                OnBack: () => {
                    RouterModule_nav(ofArray(["settings", "user-management", "api", UserId__get_unwrap(props.ApiReceiverId)]), 1, 1);
                },
                OnSave: () => {
                    dispatch(new Msg(4, []));
                },
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

